module.exports = __webpack_public_path__ + "img/maze_triangular_c.f60097cd.svg";